import React, { useState } from "react";
import PackageApi from "../../api/PackageApi";

function AddDetails({ onAdded }) {
  const [packageName, setPackageName] = useState("");
  const [modules, setModules] = useState([
    { moduleName: "", description: "" },
  ]);

  // ➕ Add Row
  const addRow = () => {
    setModules([...modules, { moduleName: "", description: "" }]);
  };

  // ❌ Delete Row
  const deleteRow = (index) => {
    const updated = modules.filter((_, i) => i !== index);
    setModules(updated);
  };

  // ✏️ Change
  const handleChange = (index, field, value) => {
    const updated = [...modules];
    updated[index][field] = value;
    setModules(updated);
  };

  // 🚀 Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    await PackageApi.add({
      packageName,
      modules,
    });

    // modal close
    const modalEl = document.getElementById("add-package-modal");
    const modalInstance = window.bootstrap.Modal.getInstance(modalEl);
    modalInstance.hide();

    // reset
    setPackageName("");
    setModules([{ moduleName: "", description: "" }]);

    if (onAdded) onAdded();
  };

  return (
    <div className="modal-dialog modal-lg">
      <div className="modal-content">
        <div className="modal-header">
          <h4>Add Package</h4>
          <button className="btn-close" data-bs-dismiss="modal" />
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">

            {/* Package Name */}
            <div className="mb-3">
              <label>Package Name</label>
              <input
                type="text"
                className="form-control"
                value={packageName}
                onChange={(e) => setPackageName(e.target.value)}
              />
            </div>

            {/* Modules */}
            <div>
              <div className="d-flex justify-content-between mb-2">
                <h5>Modules</h5>
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={addRow}
                >
                  + Add Row
                </button>
              </div>

              {modules.map((row, index) => (
                <div className="row mb-2" key={index}>
                  <div className="col-md-4">
                    <input
                      type="text"
                      placeholder="Module Name"
                      className="form-control"
                      value={row.moduleName}
                      onChange={(e) =>
                        handleChange(index, "moduleName", e.target.value)
                      }
                    />
                  </div>

                  <div className="col-md-6">
                    <textarea
                      placeholder="Description"
                      className="form-control"
                      value={row.description}
                      onChange={(e) =>
                        handleChange(index, "description", e.target.value)
                      }
                    />
                  </div>

                  <div className="col-md-2">
                    {modules.length > 1 && (
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() => deleteRow(index)}
                      >
                        ❌
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>

          </div>

          <div className="modal-footer">
            <button className="btn btn-secondary" data-bs-dismiss="modal">
              Close
            </button>
            <button type="submit" className="btn btn-primary">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddDetails;